<template>
  <div class="home">

    <div class="content">
      <h2 id="title">車両一覧</h2>
      <div id="map" ref="map">
      </div>
    </div>
  </div>

</template>

<script>
  import {db, auth, apiKey} from '../firebase'
  import moment from 'moment'
  import {Subject, Observable, combineLatest, asyncScheduler, asapScheduler} from 'rxjs'
  import axios from 'axios'
  import qs from 'querystringify'

  const isSuperResponsive = false
  var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

  let includePinsToBounds = false //マップ描画時のズーム時にお届け先も画面内に全部含めるかどうかのフラグ

  var didAddedPins = false
  var didAddedMarkers = false


  export default {
    name: 'HomeDashboard',

    created() {
      var _this = this

      //10秒に1度、ピンのリフレッシュをかける
      this.timer = setInterval(function () {
        _this.simpleDriverMarkers()
        _this.simpleOrderPins()
      }, 10000)

      //50分に一度Tokenをリフレッシュする
      this.refreshTokenTimer = setInterval(function () {
        _this.refreshToken()
      }, 1000 * 60 * 50)

      this.driverFetchSubject = new Subject()
      this.destinationFetchSubject = new Subject()
      this.mapLoadSubject = new Subject()

      this.$watch('drivers', function (value) {
        console.log('drivers changed, and position updated', value.length)

        this.needDriverPinRefresh = true

        if (isSuperResponsive) {
          this.simpleDriverMarkers()
        }
      })

      this.$watch('orders', function (value) {
        console.log('orders changed, and position updated', value.length)

        this.needOrderPinRefresh = true

        //オーダーの状態が変わって、配送中でないドライバーが出てくる可能性があるので、ここでもneedDriverPinRefreshをtrueにする。
        this.needDriverPinRefresh = true

        if (isSuperResponsive) {
          this.simpleOrderPins()
        }
      })
    },


    data() {
      return {
        map: null,
        orders: [],
        drivers: [],

        markers: {},
        pins: {},

        mapboxMarkers: {},
        mapboxPins: {},

        markersWithInfo: {},
        pinsWithInfo: {},



        perPage: 150,
        currentPage: 1, //最初のページは1 (0ではない)

        isFirstOrderShown: true,
        isLastOrderShown: false,

        driverFetchSubject: null,
        destinationFetchSubject: null,
        mapLoadSubject: null,

        needDriverPinRefresh: false,
        needOrderPinRefresh: false,

        subscription: null,
        timer: null,
        refreshTokenTimer: null
      }
    },

    computed: {

      paginationInfo() {
        let idx = this.currentPage - 1
        let from = idx * this.perPage + 1
        let to = from + this.orders.length - 1
        return `${from} -  ${to}`
      },

      leftArrowSrc() {
        if (this.isFirstOrderShown) {
          return require("@/assets/arrow_left_inactive@2x.png")
        } else {
          return require("@/assets/arrow_left_active@2x.png")
        }
      },

      rightArrowSrc() {
        if (this.isLastOrderShown) {
          return require("@/assets/arrow_right_inactive@2x.png")
        } else {
          return require("@/assets/arrow_right_active@2x.png")
        }
      },

      position: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']

          if (tracking != null) {
            let position = tracking['position']
            if (position != null) {
              return position.latitude + ", " + position.longitude
            }
          }
          return "";
        };
      },

      trackingDatetime: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']
          if (tracking != null) {
            let date = tracking['datetime'].toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      orderCreatedDatetime: function () {
        self = this;
        return function (order) {
          let createdAt = order['createdAt']
          if (createdAt != null) {
            let date = createdAt.toDate()
            return moment(date).format('YYYY/MM/DD HH:mm')
          }
          return ""
        };
      },

      companyId() {
        let coId = this.$store.getters.companyId
        if (coId) {
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },
    },


    methods: {
      fitMapToBounds() {
        var south = null
        var west = null
        var north = null
        var east = null

        for (var key in this.mapboxMarkers) {
          let marker = this.mapboxMarkers[key]
          let lngLat = marker.getLngLat().wrap()
          let lng = lngLat.lng
          let lat = lngLat.lat

          if (west == null) {
            west = lng
          } else {
            if (west > lng) {
              west = lng
            }
          }
          if (east == null) {
            east = lng
          } else {
            if (east < lng) {
              east = lng
            }
          }

          if (south == null) {
            south = lat
          } else {
            if (south > lat) {
              south = lat
            }
          }

          if (north == null) {
            north = lat
          } else {
            if (north < lat) {
              north = lat
            }
          }
        }


        if (includePinsToBounds) {
          for (var pinKey in this.mapboxPins) {
            let marker = this.mapboxPins[pinKey]
            let lngLat = marker.getLngLat().wrap()
            let lng = lngLat.lng
            let lat = lngLat.lat

            if (west == null) {
              west = lng
            } else {
              if (west > lng) {
                west = lng
              }
            }
            if (east == null) {
              east = lng
            } else {
              if (east < lng) {
                east = lng
              }
            }

            if (south == null) {
              south = lat
            } else {
              if (south > lat) {
                south = lat
              }
            }

            if (north == null) {
              north = lat
            } else {
              if (north < lat) {
                north = lat
              }
            }
          }
        }


        this.map.fitBounds([
          [west - 0.02, south - 0.02],
          [east + 0.02, north + 0.02]
        ]);
      },


      positionTimeString(position_time) {
        if (position_time != null) {
          let date = position_time.toDate()
          return moment(date).format('YYYY/MM/DD HH:mm')
        }
        return ''
      },

      //docの配列を取得（dataの配列ではない）
      async fetchNextOrders() {

        try {
          let querySnapshot
          if (this.orders.length > 0) {
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').where("status", "==", "started").orderBy("createdAt", "desc").startAfter(this.orders[this.orders.length - 1]).limit(this.perPage).get()
          } else {
            querySnapshot = await db.collection('companies').doc(this.companyId).collection('orders').where("status", "==", "started").orderBy("createdAt", "desc").limit(this.perPage).get()
          }

          if (querySnapshot.size > 0) {
            console.log("querySnapshot", querySnapshot);
            if (this.orders.length === 0) {
              this.isFirstOrderShown = true
              this.currentPage = 1
            } else {
              this.isFirstOrderShown = false
              this.currentPage++
            }
            this.orders = querySnapshot.docs

            if (this.orders.length < this.perPage) {
              this.isLastOrderShown = true
            }

            console.log('fetchNextOrders onNext()')


            this.destinationFetchSubject.next()
          } else {
            console.log("No such order");
            this.isLastOrderShown = true
          }
        } catch (error) {
          console.log("Error while fetching next orders", error);
        }
      },


      getDrivers() {
        let self = this

        this.$bind('drivers', db.collection('companies').doc(this.companyId).collection('drivers')).then(drivers => {
          console.log("getDrivers done", drivers)
          //this.getDrivers(orders, self)
          self.driverFetchSubject.next()
        })
      },

      getDriverName(driverId) {
        if (driverId == null) {
          return null
        } else {
          let chosenDriver = this.drivers.find(driver => driver.id === driverId)
          if (chosenDriver != null) {
            return chosenDriver.name
          } else {
            return null
          }
        }
      },

      simpleDriverMarkers() {
        if (this.needDriverPinRefresh) {
          console.log('simpleDriverMarkers does actual refresh')

          var newMapboxMarkers = {}

          for (let i = 0; i < this.orders.length; i++) {
            let order = this.orders[i].data()
            let orderId = this.orders[i].id

            for (let j = 0; j < this.drivers.length; j++) {
              let driver = this.drivers[j]

              if (driver.id === order.driver_id && order.status === "started") {
                //送迎状態のときのみ位置を表示
                if (driver.latitude && driver.longitude) {
                  var lngLat = [driver.longitude, driver.latitude];
                  let elementId = "marker-" + driver.id

                  var markerUpdate = false


                  let existingMarker = this.mapboxMarkers[elementId]
                  if (existingMarker) {
                    console.log("marker exists, updated the LngLat")
                    existingMarker.setLngLat(lngLat)
                    newMapboxMarkers[elementId] = existingMarker
                    markerUpdate = true
                  }

                  /*
                  for (let k = 0; k < this.mapboxMarkers.length; k++) {
                    let existingMarker = this.mapboxMarkers[k]

                    let id = existingMarker.getElement().id

                    if (id === elementId) {
                      //Marker already exist
                      existingMarker.setLngLat(lngLat)
                      newMapboxMarkers.push(existingMarker)
                      markerUpdate = true
                      break
                    }
                  }
                  */

                  if (!markerUpdate) {
                    var el = document.createElement('div')
                    let newElementId = "marker-" + driver.id
                    el.id = newElementId
                    el.className = 'marker'

                    var imageSrc = require("@/assets/driver_pin@2x.png")
                    if (driver.vehicleType && driver.vehicleType === "bike") {
                      imageSrc = require("@/assets/bike_pin@2x.png")
                    }
                    var img = new Image();
                    img.src = imageSrc
                    //img.src=  "../assets/driver_pin.png";
                    img.className = 'pinMarkerImage';
                    img.width = 30
                    img.height = 30
                    el.appendChild(img);


                    var popup = new mapboxgl.Popup({offset: 25, closeOnClick: false}) // add popups
                      .setHTML('<p>'
                        + driver.name
                        + '</p><p>'
                        + this.positionTimeString(driver.position_time)
                        + '</p>')


                    let mapboxMarker = new mapboxgl.Marker(el, {offset: [0, -10]})
                      .setLngLat(lngLat)
                      .setPopup(popup) // sets a popup on this marker
                      .addTo(this.map);

                    //newMapboxMarkers.push(mapboxMarker)
                    newMapboxMarkers[newElementId] = mapboxMarker
                  }

                }
                break
              }
            }
          }

          console.log("mapboxMarkers.length = " + Object.keys(this.mapboxMarkers).length)
          console.log("newMapboxMarkers.length = " + Object.keys(newMapboxMarkers).length)

          for (var key in this.mapboxMarkers) {
            if (!newMapboxMarkers[key]) {
              console.log("removing a marker since this is driver is gone")
              this.mapboxMarkers[key].remove()
            }else{
              console.log("not removing a marker since this driver is still there")
            }
          }

          this.mapboxMarkers = newMapboxMarkers
          //this.markers = newMarkerList //ここではじめてMapがリロードされる。forループのなかでmarkersにpushされるとその都度Mapがリロードされてしまう。
          //this.markersWithInfo = newMarkersWithInfo //ディスプレイ表示中のマーカーの情報を引き継ぐ

          this.needDriverPinRefresh = false
        }
      },

      simpleOrderPins() {
        if (this.needOrderPinRefresh) {
          console.log('simpleOrderPins does actual refresh')
          var _this = this
          var newMapboxPins = {}

          this.orders.forEach(function (doc, i) {
            let order = doc.data()

            var lngLat = [order.destination_longitude, order.destination_latitude];
            let elementId = "pin-" + doc.id

            var markerUpdate = false

            let existingPin = _this.mapboxPins[elementId]
            if (existingPin) {
              console.log("pin exists, updated the LngLat")
              existingPin.setLngLat(lngLat)
              newMapboxPins[elementId] = existingPin
              markerUpdate = true
            }

            /*
            for (let k = 0; k < _this.mapboxPins.length; k++) {
              let existingPin = _this.mapboxPins[k]

              let id = existingPin.getElement().id

              if (id === elementId) {
                //Pin already exist
                existingPin.setLngLat(lngLat)
                newMapboxPins.push(existingPin)
                markerUpdate = true
                break
              }
            }
            */

            if (!markerUpdate) {
              var el = document.createElement('div');
              el.id = "pin-" + doc.id;
              el.className = 'marker';

              var img = new Image();
              img.src = require("@/assets/place-24px.svg")
              //img.src=  "../assets/driver_pin.png";
              img.className = 'pinMarkerImage';
              img.width = 30
              img.height = 30
              el.appendChild(img);


              // create the popup
              var popup = new mapboxgl.Popup({offset: 25, closeOnClick: false}) // add popups
                .setHTML('<p>'
                  + 'Id: ' + doc.id
                  + '</p>'
                  + '<p>'
                  + order.name
                  + '</p>'
                  + '<p>'
                  + 'to: ' + order.destination_name
                  + '</p>'
                  + '<p>'
                  + 'from ' + order.client
                  + '</p>'
                )

              let mapboxPin = new mapboxgl.Marker(el, {offset: [0, -10]})
                .setLngLat(lngLat)
                .setPopup(popup) // sets a popup on this marker
                .addTo(_this.map);

              //newMapboxPins.push(mapboxPin)
              newMapboxPins[elementId] = mapboxPin
            }


          })

          console.log("mapboxPins.length = " + Object.keys(_this.mapboxPins).length)
          console.log("newMapboxPins.length = " + Object.keys(newMapboxPins).length)

          for (var key in _this.mapboxPins) {
            if (!newMapboxPins[key]) {
              console.log("removing a pin since this is driver is gone")
              _this.mapboxPins[key].remove()
            }else{
              console.log("not removing a pin since this order is still there")
            }
          }

          _this.mapboxPins = newMapboxPins
          this.needOrderPinRefresh = false
        }
      },

      refreshToken(){

        /*
        var bodyFormData = new FormData();
        bodyFormData.set('grant_type', 'refresh_token');
        bodyFormData.set('refresh_token', auth.currentUser.refreshToken);
        */


        /*
        const requestBody = {
          grant_type: 'refresh_token',
          refresh_token: auth.currentUser.refreshToken,
        }
        const requestBodyString = qs.stringify(requestBody,"")
        console.log('form:', requestBodyString)

        let config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        };


        let url = 'https://securetoken.googleapis.com/v1/token?key=' + apiKey

        axios.post(url, requestBodyString, config)
          .then(function (response) {
            //handle success
            console.log(response);
          })
          .catch(function (response) {
            //handle error
            console.log(response.message);
          });
          */


        console.log('refreshToken starts')
        auth.currentUser.getIdToken(true)
          .then(function (idToken) {

            console.log('refresh token done')

            //console.log('newToken', idToken);

            /* login状態をテストするテストコード
            console.log("check")
            auth.onAuthStateChanged(function (user) {
              if (user) {
                console.log("logged in")

              } else {
                console.log("not logged in yet")

              }
            })
            */

          }).catch(function (error) {
          console.log('refreshToken error:', error);
        })
      }


    },


    filters: {
      moment: function (date) {
        return moment(date).format('YYYY/MM/DD HH:mm');
      }
    },

    mounted() {

      mapboxgl.accessToken = 'pk.eyJ1IjoibWl6dXRvcmkiLCJhIjoiY2s4djlyemJrMGg4MzNlcWg3Z2p6NGh4MyJ9.Fb-dUr7B8xt79uegbrBnKw';


      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mizutori/ck8vrbunu2lnp1iodz3mz4pup',
        center: [139.6955122, 35.6958702],
        zoom: 14
      });


      var _this = this


      this.map.on('load', function () {

        // 何故かスタイルに設定した言語設定が反映されないので、コードで反映する。
        _this.map.setLayoutProperty('country-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('state-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('settlement-major-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('settlement-minor-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('settlement-subdivision-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('airport-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('poi-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('water-point-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('water-line-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('natural-point-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('natural-line-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('waterway-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('path-pedestrian-label', 'text-field', ['get', 'name_ja']);
        _this.map.setLayoutProperty('road-label-simple', 'text-field', ['get', 'name_ja']);

        _this.mapLoadSubject.next()


      })

      this.map.addControl(new mapboxgl.NavigationControl());
      if (!this.companyId) {
        this.$router.push('/signin')
      } else {
        //this.getOrders()
        this.fetchNextOrders()
        this.getDrivers()

        let _this = this
        this.subscription = combineLatest(this.driverFetchSubject, this.destinationFetchSubject, this.mapLoadSubject).subscribe(
          () => {
            console.log('combineLatest', _this.pins)
            this.simpleDriverMarkers()
            this.simpleOrderPins()
            this.fitMapToBounds()
          }
        );
      }
    },

    beforeDestroy() {
      clearInterval(this.timer)
      clearInterval(this.refreshTokenTimer)
    }
  }
</script>

<style scoped>
  .marker {
    display: block;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 0;
  }


  .pinMarkerImage {

  }

  .mapboxgl-popup {
    max-width: 200px;
  }

  .mapboxgl-popup-content {
    text-align: center;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, 'ヒラギノ角ゴシック Pro', 'Hiragino Kaku Gothic Pro', メイリオ, Meiryo, Osaka, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    font-weight: bold;
    font-size: 15px;
  }

  .driver_marker_name {
    font-weight: bold;
    font-size: 15px;
  }


  .driver_marker_time {
    font-size: 11px;
  }


  .home {
    width: 100%;
    height: 100vh;
    background-color: #F3F3F3;

  }

  .content {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 80px;
  }


  .clearfix:after {
    content: "";
    display: block;
    clear: both;

  }

  #title {
    margin: 63px 0 0 0;
    color: #5C5C5C;
    font-weight: normal;
    font-size: 30px;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #map {
    width: 100%;
    height: 680px;
    margin-top: 10px;
  }

  .button {
    text-align: center;
    margin-top: 2px;
    margin-bottom: 2px;
    padding: 7px 10px 7px 10px;
    font-size: 15px;
  }


  /* iPad対応 */
  @media (max-width: 768px) {
    .content {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      padding-bottom: 20px;
    }

    #title {
      margin: 20px 0 0 27px;
      color: #5C5C5C;
      font-weight: bold;
      font-size: 21px;
    }

    #map {
      height: 800px;
    }
  }

  /* スマホ対応 */
  @media (max-width: 400px) {
    #map {
      height: 600px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/MapDashboard.vue